import { EEducatorPermissions } from '@Enum/auth.enum'
import EducatorLayout from '@Layouts/Educator/EducatorLayout'
import React from 'react'
import { connect } from 'react-redux'

import { Route, Redirect } from 'react-router-dom'

interface IEducatorRoute {
    exact?: boolean
    path?: string
    user?: any
    component: any
}

const EducatorRoute: React.FC<IEducatorRoute> = ({
    component: Component,
    user,
    exact,
    path,
}) => {
    return (
        <Route
            exact={exact}
            path={path}
            render={(props: any) => {
                if (user?.permissions?.includes(EEducatorPermissions?.LOGIN)) {
                    return (
                        <EducatorLayout>
                            <Component {...props} />{' '}
                        </EducatorLayout>
                    )
                }
                return (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: {
                                from: props.location,
                            },
                        }}
                    />
                )
            }}
        />
    )
}

const mapStateToProps = (state: any) => {
    const { user } = state?.auth

    return {
        user,
    }
}

export default connect(mapStateToProps, null)(EducatorRoute)
